//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
let d=[[[0,"DoubleDefaultValue",1,0],[0,"EnumerationDefaultValue",1,0],[0,"GroupState",1,0],[0,"IntegerDefaultValue",1,0],[0,"ItemType",1,0],[0,"ParameterID",1,0],[0,"ParameterStatus",1,0],[0,"StringDefaultValue",1,0],[0,"ToggleDefaultValue",1,0],[0,"UILabel",1,0]],[[["nEnumerationItems"],"GetEnumerationItems",{R_:{enumerationItems:""}},0,0],[["enumerationItems"],"SetEnumerationItems",{},1,0],[["parentBuilder"],"SetGroup",{},1,0]],[]];
SPLM.SIM.PostConfigurator.UdeParameterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.UdeParameterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.PostConfigurator.UdeParameterBuilder.Type = Object.freeze({
    "Group" : "Group", "Double" : "Double", "Integer" : "Integer", "String" : "String", "Boolean" : "Boolean", "Enumeration" : "Enumeration", "Vector" : "Vector", "Point" : "Point", "Bitmap" : "Bitmap"});

SPLM.SIM.PostConfigurator.UdeParameterBuilder.GroupStateType = Object.freeze({
    "Open" : "Open", "Closed" : "Closed", "End" : "End"});

SPLM.SIM.PostConfigurator.UdeParameterBuilder.ParameterStatusType = Object.freeze({
    "None" : "None", "On" : "On", "Off" : "Off"});

export default SPLM;